import { Model } from 'mobx-rest'

export class UserGroups extends Model {
    constructor(attributes) {
        super(Object.assign({}, attributes))
    }

    urlRoot() {
        return '/userGroups';
    }

    url() {
        return this.urlRoot();
    }
}
